/**
-----------------------------------------------------------
normalize-japanese-addresses
japanese-admins

MIT License

Copyright 2020 Geolonia Inc.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
-----------------------------------------------------------
japanese-prefectural-capitals

MIT License

Copyright (c) 2021 Junya Ishihara

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
-----------------------------------------------------------
*/

import axios from 'axios'
import { normalize, NormalizeResult } from '@geolonia/normalize-japanese-addresses'

const addressApi = axios.create({
  headers: {
    'Content-type': 'application/json;charset=UTF-8',
  },
  timeout: 1000 * 300, // ms
})

const getCommon = async <D>(url: string): Promise<D> => {
  const response = await addressApi.get(url)
  return response.data as D
}

const sreachAddress = async (address: string) => {
  const result = await normalize(address)

  if (result.level === 1) {
    const endpoint = 'https://geolonia.github.io/japanese-prefectural-capitals/index.json'
    const data = await getCommon<any>(endpoint)
    
    result.lat = data[result.pref].lat
    result.lng = data[result.pref].lng
    return result as NormalizeResult
  }
  else if (result.level === 2) {
    const endpoint = 'https://geolonia.github.io/jisx0402/api/v1/all.json'
    const data = await getCommon<any>(endpoint)

    const keys = Object.keys(data)
    const values = Object.values(data)
    let city = result.city
    if(result.city.indexOf("郡") !== -1) {
      city = result.city.substring(result.city.indexOf("郡") + 1, result.city.length)
    }
    const index = values.findIndex((value: any) => value.prefecture === result.pref && value.city === city)
    const code = keys[index].substring(0, 5)

    const endpoint2 = `https://geolonia.github.io/japanese-admins/${code.substring(0, 2)}/${code}.json`
    const data2 = await getCommon<any>(endpoint2)
    
    result.lat = data2.features[0].geometry.coordinates[0][0][1]
    result.lng = data2.features[0].geometry.coordinates[0][0][0]
    return result as NormalizeResult
  }
  else {
    return result as NormalizeResult
  }
}

export default {
  sreachAddress,
}